<template>
  <div class="table-container mb-4">
    <div class="table-title py-4 ps-4 ps-sm-6">{{$t(title)}}</div>
    <div class="table-item-container list-item-container" v-for="(item,index) in itemList"
         @click="onItemClick(item)" @mouseover="currentIndex = index" @mouseleave="currentIndex = false" :class="{'disabled' : item.disabled}">
      <div class="item py-6 d-flex justify-sm-space-between">
        <div class="item-title px-sm-6">{{$t('report.reports.meta_data.'+item.name+'.name')}}</div>
        <div class="item-description d-none d-sm-block">{{$t('report.reports.meta_data.'+item.name+'.description')}}</div>
        <v-icon class="item-icon justify-end  align-self-start align-self-sm-center ps-4 pe-3 pe-sm-6 ps-sm-0"
                :class="item.type">
          {{item.icon}}
        </v-icon>
        <v-icon class="item-icon-arrow align-self-center justify-end px-4 ps-sm-0 pe-sm-6">{{ icon }}</v-icon>
      </div>
      <div class="item-divider mx-4 mx-sm-6" v-if="(index !== itemList.length - 1)" :style="[(!item.disabled) && (currentIndex - 1 === index)  ? {opacity: 0} : '' ]"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TableItems",
    data: function () {
      return {
        currentIndex: null
      }
    },
    props: {
      title: {type: String, required: true},
      itemList: {type: Array, required: true}
    },
    methods:{
      onItemClick(item) {
        this.$emit('itemClicked', item)
      }
    },
    computed:{
      icon(){
        return this.$vuetify.rtl ? 'icon-Chevron-left_reports' : 'icon-Chevron-right_reports'
      }
    }
  };
</script>
<style lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .table-container{
    background: white;
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.06), 0px 3px 1px -2px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    font-size: 16px;
    .table-title{
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: #757575;
      border-bottom: 1px solid #eaedf2;
    }
    .table-item-container{
      cursor: pointer;
      transition: 0.3s;
      .item-title{
        @include xs-and-down{order: 1;font-size: 13px;};
        @include md-and-up-main{flex: 2; font-size: 14px;}
        font-weight: 600;
      }
      .item-description{
        color: $black-color-1;
        font-size: 13px;
        opacity: 0.62;
        flex: 4;
      }
      .item-icon{
        font-size: 16px;
        @include xs-and-down{order: 0;line-height: 21px;};
        @include md-and-up-main{flex: 1};
        &.chart{
          color: #98E4BA;
        }
        &.table{
          color: #FFDC70;
        }
      }
      .item-icon-arrow{
        flex: 1;
        color: rgba(0, 0, 0, 0.3);
        font-size: 14px;
        @include xs-and-down{order: 2; flex: 1};
      }
      .item-divider{
        height: 1px;
        background: #EAEDF2;
      }
      &:hover:not(.disabled){
        background: rgba(0, 0, 0, 0.03);
        .item-divider{opacity: 0}
        .item-icon-arrow{color: #000000}
        .item-icon{
          &.table{color: #FFC511;}
          &.chart{color: #54D28C;}
        }
      }
      &.disabled {
        background: rgba(0, 0, 0, 0.02);
        color:  rgba(0, 0, 0, 0.54);
        .item-icon{color: #00000033;}
      }
    }

  }
</style>
